import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const PROJECT_TOKEN_KEY = 'readonly_project_share_token';
const PROJECT_ID_KEY = 'readonly_project_share_id';

export function getStoredReadonlyProjectShareToken(): string | null {
  return sessionStorage.getItem(PROJECT_TOKEN_KEY);
}

function persistProjectShare(token: string | null, resourceId: string | null) {
  if (token) {
    sessionStorage.setItem(PROJECT_TOKEN_KEY, token);
  } else {
    sessionStorage.removeItem(PROJECT_TOKEN_KEY);
  }

  if (resourceId) {
    sessionStorage.setItem(PROJECT_ID_KEY, resourceId);
  } else {
    sessionStorage.removeItem(PROJECT_ID_KEY);
  }
}

interface ShareAccessState {
  readonlyProjectShareToken: string | null;
  readonlyProjectId: string | null;
  enableProjectReadonlyShare: (token: string, projectId: string) => void;
  clearProjectReadonlyShare: () => void;
  restoreFromSession: () => void;
}

export const useShareAccessStore = create<ShareAccessState>()(
  devtools(
    (set) => ({
      readonlyProjectShareToken: getStoredReadonlyProjectShareToken(),
      readonlyProjectId: sessionStorage.getItem(PROJECT_ID_KEY),

      enableProjectReadonlyShare: (token, projectId) => {
        persistProjectShare(token, projectId);
        set({
          readonlyProjectShareToken: token,
          readonlyProjectId: projectId,
        });
      },

      clearProjectReadonlyShare: () => {
        persistProjectShare(null, null);
        set({
          readonlyProjectShareToken: null,
          readonlyProjectId: null,
        });
      },

      restoreFromSession: () =>
        set({
          readonlyProjectShareToken: getStoredReadonlyProjectShareToken(),
          readonlyProjectId: sessionStorage.getItem(PROJECT_ID_KEY),
        }),
    }),
    { name: 'ShareAccessStore' }
  )
);
